import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import api from '../../services/api';

const TeamMember = () => {
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Slider settings
  const settingsteam = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
    ],
    prevArrow: (
      <button className="bg-gray-800 text-white p-2 rounded">
        <i className="la la-angle-left"></i>
      </button>
    ),
    nextArrow: (
      <button className="bg-gray-800 text-white p-2 rounded">
        <i className="la la-angle-right"></i>
      </button>
    ),
  };

  useEffect(() => {
    const fetchTeamMembers = async () => {
      try {
        const response = await api.get(
          'https://www.startupbusinesspartners.com/api/team_members',
          {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
          }
        );

        if (response.data.success) {
          setTeamMembers(response.data.data);
        } else {
          throw new Error(response.data.message || 'Failed to fetch team members');
        }
      } catch (err) {
        setError(err.message);
        console.error('Error fetching team members:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchTeamMembers();
  }, []);

  if (loading) {
    return (
      <div className="text-center py-8">
        <div className="inline-block animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
        <p className="mt-2">Loading team members...</p>
      </div>
    );
  }

  if (error) {
    return <div className="text-center py-8 text-red-500">Error: {error}</div>;
  }

  return (
    <>
   

      <section className="py-24 bg-gray-100">
        <div className="container mx-auto px-4 bg-white shadow-lg rounded-lg p-6">
          {teamMembers.length > 0 ? (
            <Slider {...settingsteam}>
              {teamMembers.map((member) => (
                <div key={member.id} className="px-4">
                  <div className="text-center transform transition-transform hover:scale-105">
                    <img
                      src={
                        member.profile_image
                          ? `https://www.startupbusinesspartners.com/uploads/cms/${member.profile_image}`
                          : 'https://via.placeholder.com/150'
                      }
                      style={{width:'300px', height:'260px'}}
                      alt={member.name}
                      className="w-24 h-24 rounded-full mx-auto mb-4 object-cover"
                    />
                    <h6 className="text-lg font-semibold mb-1">
                      {member.name}
                    </h6>
                    <span className="text-teal-500 text-sm">{member.position}</span>

            
                  </div>
                </div>
              ))}
            </Slider>
          ) : (
            <div className="text-center py-8">No team members found</div>
          )}
        </div>
      </section>

    </>
  );
};

export default TeamMember;
